
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/airtable",
      function () {
        return require("private-next-pages/destinations/airtable.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/airtable"])
      });
    }
  